import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const FilterControls = ({ statusFilter, dateFilter, searchQuery, onStatusChange, onDateChange, onSearchChange }) => {
  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'delivered', label: 'Delivered' },
    { value: 'in transit', label: 'In Transit' },
    { value: 'out for delivery', label: 'Out for Delivery' },
    { value: 'pending', label: 'Pending' }
  ];

  const dateOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'week', label: 'Last 7 Days' },
    { value: 'month', label: 'Last 30 Days' },
    { value: '3months', label: 'Last 3 Months' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="text-sm font-body font-medium text-foreground mb-2 block">
            <Icon name="Filter" size={14} className="inline mr-1" />
            Filter by Status
          </label>
          <Select
            options={statusOptions}
            value={statusFilter}
            onChange={(e) => onStatusChange(e?.target?.value)}
            placeholder="Select status"
          />
        </div>

        <div>
          <label className="text-sm font-body font-medium text-foreground mb-2 block">
            <Icon name="Calendar" size={14} className="inline mr-1" />
            Filter by Date
          </label>
          <Select
            options={dateOptions}
            value={dateFilter}
            onChange={(e) => onDateChange(e?.target?.value)}
            placeholder="Select date range"
          />
        </div>

        <div>
          <label className="text-sm font-body font-medium text-foreground mb-2 block">
            <Icon name="Search" size={14} className="inline mr-1" />
            Search Shipments
          </label>
          <Input
            type="text"
            placeholder="Tracking #, recipient, or contents..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterControls;